// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"296":"7ef28547","364":"9e5f4757","615":"7ef28547","822":"7ef28547"}[chunkId] + ".chunk.css";
};